// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchResultLoader_container__AFoA7"};